<!--
    Styles
-->

<style>

    .ui-dropdown {
        position: relative;
    }
    .ui-dropdown > * + *:last-child, .ui-dropdown .dropdown {
        position: absolute;
        top: 100%;
        right: 0;
        min-width: 100%;
    }

</style>



<!--
    Template
-->

<template>
    <div class="ui-dropdown" v-click-away="hide">
        <slot :active="active" :toggle="toggle" />
    </div>
</template>



<!--
    Scripts
-->

<script>


    import clickAway from '@/common/directives/click-away'


    export default {

        directives: {
            clickAway
        },

        data () {
            return {
                active: false
            }
        },

        methods: {

            toggle () {
                this.active = !this.active
            },

            hide () {
                this.active = false
            }

        }

    }

</script>

